var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-checkbox',{staticClass:"checkbox",model:{value:(_vm.value.data),callback:function ($$v) {_vm.$set(_vm.value, "data", $$v)},expression:"value.data"}})}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1c8875ad","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/lib/components/Checkbox.vue
// module id = ev/8
// module chunks = 1